/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step4_AiInputs */

const en_dr_step4_ai = /** @type {(inputs: Dr_Step4_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locked until reveal; after reveal it clusters, flags duplicates, critiques from a persona`)
};

const id_dr_step4_ai = /** @type {(inputs: Dr_Step4_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terkunci sampai reveal; setelah reveal ia mengelompokkan, menandai duplikat, mengkritik dari sudut persona`)
};

/**
* | output |
* | --- |
* | "Locked until reveal; after reveal it clusters, flags duplicates, critiques from a persona" |
*
* @param {Dr_Step4_AiInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step4_ai = /** @type {((inputs?: Dr_Step4_AiInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step4_AiInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step4_ai(inputs)
	return en_dr_step4_ai(inputs)
});